import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { first } from 'rxjs';
import { GungModalService } from '../../services/gung-modal/gung-modal.service';

@Component({
  selector: 'lib-edi-pricat-generate-modal',
  templateUrl: './edi-pricat-generate-modal.component.html',
  styleUrls: ['./edi-pricat-generate-modal.component.css'],
  standalone: false
})
export class EdiPricatGenerateModalComponent implements OnInit {
  configs: any[] = [];
  selectedConfigId: string = '';
  selectedBuyerGln: number | null = null;
  glnOptions: any[] = [];

  delegate: GungModalService;
  componentId: string;

  constructor(protected http: HttpClient) {}

  ngOnInit(): void {
    this.componentId = EdiPricatGenerateModalComponent.name;

    this.http.get<any[]>('json/gung/edi/configs').pipe(first()).subscribe(configs => {
      this.configs = configs.filter(c => c.edifactPricatTransformerQualifier);
      if (this.configs.length === 1) {
        this.selectedConfigId = this.configs[0].id;
        this.onConfigSelected();
      }
    });
  }

  onConfigSelected(): void {
    const config = this.configs.find(c => c.id === this.selectedConfigId);
    this.glnOptions = config?.pricatGlnConfigs || [];
    this.selectedBuyerGln = null;
    if (this.glnOptions.length === 1) {
      this.selectedBuyerGln = this.glnOptions[0].gln;
    }
  }

  isValid(): boolean {
    return !!this.selectedConfigId && this.selectedBuyerGln != null;
  }

  confirm(): void {
    this.delegate.modalRef.get(this.componentId).close({
      ediConfigId: this.selectedConfigId,
      buyerGln: this.selectedBuyerGln
    });
  }

  cancel(): void {
    this.delegate.modalRef.get(this.componentId).close(null);
  }
}
